import { MapDispatchToProps, MapStateToPropsFactory } from "react-redux";
import { Dispatch } from "redux";

import { emitMatchMePreferenceToggled } from "../../contract/betslip-api";
import { getExchangePotentialState } from "../../store/state/exchange-betting-potential/exchange-betting-potential-selectors";
import { BetslipApplicationState } from "../../store/state/BetslipApplicationState";
import { createRunnerPotentialBetsSelector } from "../../store/state/exchange-betting/runner-potential-bets-selectors";
import { type BetslipExchangeMatchMeModalAction, UI__BETSLIP_EXC_MATCH_ME_MODAL } from "@ppb/tbd-store/actions/betslip";

import type { ExchangeBetslipPreferences } from "../../contract";
import { MatchMeOddsRange } from "./types";
import type { ExchangeSide } from "../../types";

export type ContainerProps = {
  selectionUrn: string;
  side: ExchangeSide;
  preferences: ExchangeBetslipPreferences;
};

export type StateProps = {
  isEnabled: boolean;
  oddsRange: MatchMeOddsRange;
  label: string;
  price?: number;
};

export type DispatchProps = {
  onToggle: (value: boolean) => void;
  dispatchBetslipExchangeMatchMeModalAction: (isOpened: boolean) => void;
};

export const makeMapStateToProps: MapStateToPropsFactory<StateProps, ContainerProps, BetslipApplicationState> = () => {
  const getRunnerPotentialBets = createRunnerPotentialBetsSelector();

  return function mapStateToProps(state: BetslipApplicationState, ownProps: ContainerProps): StateProps {
    const isEnabled = ownProps.preferences.matchMe.enabled;

    const { selectionUrn, side } = ownProps;
    const potentialState = getExchangePotentialState(state, selectionUrn, side);
    const [potentialBet] = getRunnerPotentialBets(state, selectionUrn);

    const price = potentialBet?.price;
    const priceAtPlacement = potentialState?.priceAtPlacement;

    const hasPotentialRange = !!(price && priceAtPlacement && Math.abs(price - priceAtPlacement) !== 0);
    const oddsRange = hasPotentialRange ? { min: price, max: priceAtPlacement } : null;

    return {
      isEnabled,
      oddsRange,
      label: "MatchMe",
      price,
    };
  };
};

const dispatchBetslipExchangeMatchMeModalAction = (
  dispatch: Dispatch<BetslipExchangeMatchMeModalAction>,
  isOpened: boolean,
): void => {
  dispatch<BetslipExchangeMatchMeModalAction>({
    type: UI__BETSLIP_EXC_MATCH_ME_MODAL,
    payload: {
      isOpened,
    },
  });
};

export const mapDispatchToProps: MapDispatchToProps<DispatchProps, ContainerProps> = (dispatch: Dispatch) => ({
  onToggle: (value: boolean) => {
    emitMatchMePreferenceToggled({ enabled: value, surface: "PLACE" });
  },
  dispatchBetslipExchangeMatchMeModalAction: (isOpened: boolean) => {
    dispatchBetslipExchangeMatchMeModalAction(dispatch, isOpened);
  },
});
